import React from "react";

import moment from "moment";

import { useTranslation } from "utils";

import { Col, Collapse, Divider, Icon, Panel, ProgressAnimated, Row } from "components";

export const CoursePlan = ({ course, courseStarted, completedModules, onModuleSelect }) => {
  const { t } = useTranslation("courses");

  return (
    <Row gutter={0} className="course-plan-row">
      <Col className="course-plan">
        {courseStarted ? (
          <div className="margin-bottom-375">
            <ProgressAnimated finalValue={course.progress.summary} text={t("courseOverview.progressBarExplainer")} />
          </div>
        ) : (
          <h2 className="section-heading">{t("courseOverview.coursePlan")}</h2>
        )}
        <Collapse>
          {course.chapters.map((chapter, i) => (
            <Panel key={i} header={`${(i + 10).toString(36).toUpperCase()}. ${chapter.title}`}>
              {chapter.modules.map((module, i) => (
                <div key={i}>
                  {courseStarted ? (
                    <div className="module-details" onClick={() => onModuleSelect({ chapter, module })}>
                      <div className="module-title">
                        <Icon iconName={`tabler/${module.video ? "movie" : "news"}`} />
                        <span>{module.title}</span>
                      </div>
                      {completedModules.includes(module.id) ? (
                        <Icon iconName="tabler/circle-check" color="#f9ecd9" fill="#3b9361" />
                      ) : (
                        <span>
                          {module.duration >= 3600 ? moment.utc(module.duration * 1000).format("hh:mm:ss") : moment.utc(module.duration * 1000).format("mm:ss")}
                        </span>
                      )}
                    </div>
                  ) : (
                    <div className="module-details locked">
                      <div className="module-title">
                        <Icon iconName="tabler/lock" />
                        <span>{module.title}</span>
                      </div>
                      <span>
                        {module.duration >= 3600 ? moment.utc(module.duration * 1000).format("hh:mm:ss") : moment.utc(module.duration * 1000).format("mm:ss")}
                      </span>
                    </div>
                  )}
                  {i < chapter.modules.length - 1 && <Divider />}
                </div>
              ))}
            </Panel>
          ))}
        </Collapse>
      </Col>
    </Row>
  );
};
